module.exports = __webpack_public_path__ + "img/繁体.468f1e83.png";